import { useReuploadExamModal } from 'components/exams/ReuploadExamModalForm/reuploadExamModalForm.hooks';
import { TNotificationFieldsFragment } from 'generated/graphql';
import NotificationActionItem from '../NotificationActionItem';

interface IUploadExamContent {
  data: TNotificationFieldsFragment;
  onOpen: () => void;
  onCompleted: () => void;
}

const UploadExamContent = ({
  data,
  onOpen,
  onCompleted,
}: IUploadExamContent) => {
  const { openReuploadModal } = useReuploadExamModal({
    onClick: onOpen,
    onCompleted,
  });

  return (
    <NotificationActionItem
      data={data}
      onClick={() => openReuploadModal(data?.exam?._id?.toString() || '')}
    />
  );
};

export default UploadExamContent;
